import { getPageTitle } from './getPageTitle.js';
export function getPageHead(options) {
    const meta = [];
    if (options.noindex) {
        meta.push({
            name: 'robots',
            content: 'noindex,notranslate',
        });
    }
    const description = options.description;
    if (description) {
        meta.push({
            id: 'description',
            name: 'description',
            content: description,
        });
    }
    const ogTitle = options.ogTitle ?? options.title;
    if (ogTitle) {
        meta.push(createOpenGraphTag({
            name: 'og:title',
            content: ogTitle,
        }), {
            name: 'apple-mobile-web-app-title',
            content: ogTitle,
        });
    }
    const ogDescription = options.ogDescription ?? options.description;
    if (ogDescription) {
        meta.push(createOpenGraphTag({
            name: 'og:description',
            content: ogDescription,
        }));
    }
    const ogImage = options.ogImage;
    if (ogImage) {
        meta.push(createOpenGraphTag({
            name: 'og:image',
            content: ogImage,
        }));
    }
    return {
        title: options.title ? getPageTitle(options.title) : undefined,
        meta,
    };
}
function createOpenGraphTag(tag) {
    return {
        name: tag.name,
        // facebook requires tag to have 'property' instead of 'name'
        property: tag.name,
        content: tag.content,
    };
}
//# sourceMappingURL=getPageHead.js.map